// withSelectSkuId.js
'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import getProductData from '../selector/getProductData.js';
import getOperationData from '../selector/getOperationData.js';
import getModalData from '../selector/getModalData.js';
import getMeData from '../selector/getMeData.js';

import setDefaultShopCurrency from '../action/setDefaultShopCurrency.js';

import { SHOP_ID, ProductType } from '../resource/shopConstants.js';
import { addvalue as ShopModalId } from '../resource/modalId.js';

const withSelectSkuId = BaseComponent => {
  class CheckoutProduct extends React.Component {
    constructor(props) {
      super(props);
      const { staticContext } = props;
      if (staticContext.actions) {
        staticContext.actions.push({
          function: this.setUsingShopId,
          argumentObject: {},
        });
        staticContext.actions.push({
          function: this.setDefaultShopCurrency,
          argumentObject: {},
        });
        staticContext.actions.push({
          function: this.setSelectedSkuId,
          argumentObject: {},
        });
      }
    }
    setUsingShopId = () => {
      const { productType, isShopOpened, setUsingShopId } = this.props;
      // Should not update this value when shop is opened.
      // This is to prevent overwriting the value that the user has already selected.
      if (!productType || isShopOpened) {
        return;
      }
      return setUsingShopId({
        usingShopId:
          ProductType.MESSAGEPACKS === productType
            ? SHOP_ID.messagePack
            : SHOP_ID.addvalue,
      });
    };
    setDefaultShopCurrency = () => {
      const { productId, isShopOpened, currencies, setDefaultShopCurrency } =
        this.props;
      // Should not update this value when shop is opened.
      // This is to prevent overwriting the value that the user has already selected.
      if (!productId || !currencies.length || isShopOpened) {
        return;
      }
      return setDefaultShopCurrency({ productId });
    };
    setSelectedSkuId = () => {
      const {
        currency,
        currencySkuId,
        shopId,
        isShopOpened,
        setSelectedSkuId,
      } = this.props;
      const skuId = currencySkuId[currency];
      // Should not update this value when shop is opened.
      // This is to prevent overwriting the value that the user has already selected.
      if (!skuId || !shopId || isShopOpened) {
        return;
      }
      return setSelectedSkuId({
        shopId,
        skuId,
      });
    };
    componentDidMount() {
      this.setUsingShopId();
      this.setDefaultShopCurrency();
      this.setSelectedSkuId();
    }
    componentDidUpdate(prevProps) {
      const {
        meId,
        shopId,
        currency,
        productId,
        productType,
        currencySkuId,
        isShopOpened,
        currencies,
      } = this.props;
      const isProductTypeChanged = productType !== prevProps.productType;
      const isProductIdChanged = productId !== prevProps.productId;
      const isShopIdChanged = shopId !== prevProps.shopId;
      const isCurrencyChanged = currency !== prevProps.currency;
      const isCurrencySkuIdChanged = currencySkuId !== prevProps.currencySkuId;
      const isCurrenciesChanged = currencies !== prevProps.currencies;
      const isShopOpenChanged = isShopOpened !== prevProps.isShopOpened;
      const isMeIdChanged = meId !== prevProps.meId;
      if (isProductTypeChanged || isShopIdChanged || isShopOpenChanged) {
        this.setUsingShopId();
      }
      if (isProductIdChanged || isCurrenciesChanged || isShopOpenChanged) {
        this.setDefaultShopCurrency();
      }
      if (
        isShopIdChanged ||
        isCurrencyChanged ||
        isCurrencySkuIdChanged ||
        isMeIdChanged ||
        isShopOpenChanged
      ) {
        this.setSelectedSkuId();
      }
    }
    render() {
      return <BaseComponent {...this.props} />;
    }
  }

  CheckoutProduct.propTypes = {
    shopId: PropTypes.string,
    productId: PropTypes.string,
    meId: PropTypes.string,
    productType: PropTypes.string,
    currency: PropTypes.string,
    isShopOpened: PropTypes.bool,
    currencies: PropTypes.array,
    currencySkuId: PropTypes.object,
    staticContext: PropTypes.object,
    children: PropTypes.func,
    setUsingShopId: PropTypes.func,
    setDefaultShopCurrency: PropTypes.func,
    setSelectedSkuId: PropTypes.func,
  };
  CheckoutProduct.defaultProps = {
    shopId: null,
    productId: null,
    meId: null,
    productType: null,
    currency: null,
    isShopOpened: false,
    currencies: [],
    currencySkuId: {},
    staticContext: {},
    children: () => null,
    setUsingShopId: () => null,
    setDefaultShopCurrency: () => null,
    setSelectedSkuId: () => null,
  };

  const mapStateToProps = (state, { productId }) => {
    const shopId = getOperationData(state, ['shop'], 'usingShopId');
    return {
      shopId,
      productId,
      meId: getMeData(state, 'id'),
      productType: getProductData(state, [productId], 'type'),
      currency: getOperationData(state, ['shop'], 'currency'),
      isShopOpened:
        getModalData(state, ShopModalId.DIAMOND_PACK_SELECTOR, 'zIndex') !=
        null,
      currencies: getProductData(state, [productId], 'currencies'),
      currencySkuId: getProductData(state, [productId], 'currencySkuId'),
    };
  };

  const mapDispatchToProps = dispatch => {
    return {
      setUsingShopId: ({ usingShopId }) =>
        dispatch({
          type: MERGE_OPERATION_DATA,
          payload: {
            selectPath: ['shop'],
            data: {
              usingShopId,
            },
          },
        }),
      setSelectedSkuId: ({ skuId, shopId }) =>
        dispatch({
          type: MERGE_OPERATION_DATA,
          payload: {
            selectPath: ['shop', shopId],
            data: {
              selectedDiamondPackId: skuId,
            },
          },
        }),
      setDefaultShopCurrency: data => dispatch(setDefaultShopCurrency(data)),
    };
  };

  return connect(mapStateToProps, mapDispatchToProps)(CheckoutProduct);
};

export default withSelectSkuId;
